import { isNull } from './common-utils';
 
export interface GmapReadyevent {
    /**
     * untuk di invoke pada saat map ready 
     */
    (): any;
}
/**
 * class untuk memantau state dari gmap
 */
export class GmapStateManager {

    /**
     * flag map ready atau tidak
     */
    mapReady: boolean; 

    /**
     * listener untuk gmap sudah ready
     */
    private listeners: Array<GmapReadyevent> = []; 

    constructor() {
        let s: any = window['GMAP_READY_STATE'];
        if (isNull(s)) {
            s = false;
        }
        this.mapReady = s;
    } 
    /**
     * untuk mentrigger map ready
     */
    onMapReady() {
        this.mapReady = true;
        for (let p of this.listeners) {
            p();
        }
    }
    /**
     * register event handler ke manager
     * @param eventHandler handler untuk di register
     */
    register(eventHandler: GmapReadyevent) {
        if (isNull(eventHandler) || this.listeners.indexOf(eventHandler) >= 0) {
            return;
        }
        this.listeners.push(eventHandler);
    }

    /**
     * worker untuk unregister ke parent
     * @param eventHandler 
     */
    unregister(eventHandler: GmapReadyevent) {
        if (isNull(eventHandler) || this.listeners.indexOf(eventHandler) < 0) {
            return;
        }
        let idx: number = this.listeners.indexOf(eventHandler);
        this.listeners.splice(idx, 1);
    } 

}

/**
 * akses ke map manager
 */
export function getMapManager(ch: string): GmapStateManager {
    let onWindow: any = window[`GMAP_STATE_MANAGER${ch}`];
    if (isNull(onWindow)) {
        onWindow = new GmapStateManager();
        window[`GMAP_STATE_MANAGER${ch}`] = onWindow;
    }
    return onWindow;
}


// WEBPACK FOOTER //
// ./src/utils/GmapStateManager.ts